import { ItemSource } from '../../item-source';
import { ContentControlLiveSourceType } from './content-control-live-source-type.enum';

export class ContentControlLiveSource extends ItemSource {
  constructor(
    public id: string,
    public name: string,
    public type: ContentControlLiveSourceType = ContentControlLiveSourceType.Channel,
    public url: string,
    public image?: string,
  ) {
    super(id, name, image);
  }
}
